module.exports = __webpack_public_path__ + "b5a73d682611bb46b862070c581a6940.pdf";